import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Placeholder from 'react-bootstrap/Placeholder';

function CardHolders() {
  const openFacebook = () => {
    window.open('https://www.facebook.com/Joleighndjshahalsdhflsadf/', '_blank');
  };

  return (
    <div className="d-flex justify-content-around">
      <Card style={{ width: '18rem' }}>
        
        <Card.Body>
          <Card.Title>Home Page</Card.Title>
          <Card.Text>
          My career goal is to become a wed designer that focusing on modern web 
          designs.
          </Card.Text>
          <Button variant="primary" onClick={openFacebook}>Go to Facebook</Button>
        </Card.Body>
      </Card>

      <Card style={{ width: '18rem' }}>
       
        <Card.Body>
          <Placeholder as={Card.Title} animation="glow">
            <Placeholder xs={6} />
          </Placeholder>
          <Placeholder as={Card.Text} animation="glow">
            <Placeholder xs={7} /> <Placeholder xs={4} /> <Placeholder xs={4} />{' '}
            <Placeholder xs={6} /> <Placeholder xs={8} />
          </Placeholder>
          <Placeholder.Button variant="primary" xs={6} />
        </Card.Body>
      </Card>
    </div>
  );
}

export default CardHolders;
